import { Box } from '@mui/material';
import { FullScreenLayoutProps } from '../layout';

const FullScreen: React.FC<FullScreenLayoutProps> = (props) => {
  return (
    <Box
      sx={[
        { width: '100%' },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {props.children}
    </Box>
  );
};

export default FullScreen;
